import React from 'react';
import { useDialog } from '../../common/withDialog';
import { useMutation } from "@apollo/client/react";
import { userIsAdminOrMod } from '../../../lib/vulcan-users/permissions';
import { useCurrentUser } from '../../common/withUser';
import { gql } from "@/lib/generated/gql-codegen";
import LockThreadDialog from "./LockThreadDialog";
import DropdownItem from "../DropdownItem";


const LockThreadDropdownItem = ({comment}: {comment: CommentsList}) => {
  const currentUser = useCurrentUser();
  const {openDialog} = useDialog();

  const [unlockThread] = useMutation(gql(`
    mutation unlockThread($commentId: String!) {
      unlockThread(commentId: $commentId)
    }
  `));

  if (!userIsAdminOrMod(currentUser) || comment.draft) {
    return null;
  }

  const handleLockThread = () => {
    openDialog({
      name: "LockThreadDialog",
      contents: ({onClose}) => <LockThreadDialog
        onClose={onClose}
        commentId={comment._id}
      />
    });
  }

  const handleUnlockThread = async () => {
    await unlockThread({
      variables: {
        commentId: comment._id
      }
    });
    // HACK: The cient-side cache doesn't update to reflect this change, so
    // hard-refresh the page
    window.location.reload();
  }
  if (comment.repliesBlockedUntil) {
    return (
      <DropdownItem
        title={"Unlock Thread"}
        onClick={handleUnlockThread}
      />
    );
  }

  return (
    <DropdownItem
      title={"Lock Thread"}
      onClick={handleLockThread}
    />
  );
}

export default LockThreadDropdownItem;
